define('taoQtiItem/qtiItem/core/interactions/ChoiceInteraction',['taoQtiItem/qtiItem/core/interactions/BlockInteraction'], function(BlockInteraction){
    var ChoiceInteraction = BlockInteraction.extend({
        qtiClass : 'choiceInteraction'
    });
    return ChoiceInteraction;
});



